
import { reactive, toRefs, computed, ref, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { goodsquery } from '@/api/goods/index'
import filesaver from 'file-saver'
import * as XLSX from 'xlsx'
import { useStore } from '@/store/index.ts'
import Record from '@/views/goodsquery/record.vue'
export default ({
  name: 'goodsquery',
  components: { Record },
  setup () {
    const state = reactive({
      goodslist: [],
      jsm: '',
      pm: '',
      loading: false,
      total: 0,
      pagesize: 15,
      currentPage: 1,
      isShowDialog: false,
      sliceend: 1
    })

    const store = useStore()
    const RecordRef = ref()

    const search = async () => {
      state.loading = true
      const goodslist = await goodsquery({ filterstring: state.jsm, cgy: getUserInfos.value.userName })
      state.goodslist = JSON.parse(JSON.stringify(goodslist))
      // console.log(state.goodslist)
      state.total = state.goodslist.length
      state.loading = false
      ElMessage.success('查询成功')
    }
    const handleCurrentChange = (currentPage) => {
      state.currentPage = currentPage
    }
    const exportExcel = async () => {
      /* out-table关联导出的dom节点 */
      state.sliceend = state.goodslist.length
      await nextTick(() => {
        var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
        var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          filesaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '药品信息.xlsx')
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        state.sliceend = 1
        return wbout
      })
    }
    // 获取用户信息
    const getUserInfos = computed(() => {
      return store.state.userInfos.userInfos
    })
    const onGoDetailsClick = (row: object) => {
      RecordRef.value.openDialog(row)
    }
    return {
      search,
      getUserInfos,
      handleCurrentChange,
      exportExcel,
      onGoDetailsClick,
      RecordRef,
      ...toRefs(state)
    }
  }
})
